export const getTimer = (time: number) => {
  const firstNumber = Math.floor(time / 60);
  const secondNumber = time - time * Math.floor(time / 60);

  return `${firstNumber > 9 ? firstNumber : `0${firstNumber}`}:${
    secondNumber > 9 ? secondNumber : `0${secondNumber}`
  }`;
};
